import api from "../utils/API";

const getAllContrats  = () => {
  return api.get('/Contrat/list');
};

const addContrat = (name) => {
    return api.post('/Contrat/add', { name }); 
  };

export {
    getAllContrats,
    addContrat
};